// Multi-line journals created from one bank-statement line.
// The signed bank movement must equal the journal's net movement on the
// statement account before the backend is allowed to book it.
(function publishBankFreePostingLines(global) {
  const money = (value) => Math.round((Number(value) || 0) * 100) / 100;
  const code = (value) => String(value || '').match(/\b(\d{4})\b/)?.[1] || '';
  const normalize = (lines) => (Array.isArray(lines) ? lines : []).map((line, index) => ({
    id: line.id || `bank-manual-line-${index + 1}`,
    fromAccountCode: code(line.fromAccountCode || line.fromAccount),
    toAccountCode: code(line.toAccountCode || line.toAccount),
    amount: Math.abs(money(line.amount ?? line.fromAmount ?? line.toAmount)),
    fromVatCode: line.fromVatCode || 'none',
    toVatCode: line.toVatCode || 'none',
  }));
  const bankNetAmount = (lines, bankAccountCode) => money(normalize(lines).reduce((sum, line) => (
    sum + (line.toAccountCode === bankAccountCode ? line.amount : 0) - (line.fromAccountCode === bankAccountCode ? line.amount : 0)
  ), 0));
  const validate = ({ lines, bankAccountCode, bankAmount }) => {
    const normalized = normalize(lines);
    if (!normalized.length) return { ok: false, reason: 'missing-lines', lines: normalized };
    if (normalized.some((line) => !line.fromAccountCode || !line.toAccountCode || line.fromAccountCode === line.toAccountCode || line.amount <= 0)) {
      return { ok: false, reason: 'invalid-line', lines: normalized };
    }
    const bankNet = bankNetAmount(normalized, code(bankAccountCode));
    if (Math.abs(bankNet - money(bankAmount)) > 0.005) return { ok: false, reason: 'bank-mismatch', bankNet, lines: normalized };
    return { ok: true, bankNet, lines: normalized };
  };
  const postingId = ({ expenses, statementId, lineId }) => {
    const baseId = `manual-bank-${statementId}-${lineId}`;
    const related = (Array.isArray(expenses) ? expenses : []).filter((entry) => {
      const id = String(entry?.id || '');
      return entry?.manualPosting && (id === baseId || id.startsWith(`${baseId}-r`));
    });
    const inactive = new Set(['annulled', 'reversed', 'deleted']);
    const active = related.find((entry) => !inactive.has(String(entry?.status || 'active').toLowerCase()));
    if (active) return String(active.id);
    if (!related.length) return baseId;
    const highestRevision = related.reduce((highest, entry) => {
      const match = String(entry?.id || '').match(/-r(\d+)$/);
      return Math.max(highest, match ? Number(match[1]) : 0);
    }, 0);
    return `${baseId}-r${highestRevision + 1}`;
  };
  global.PlummeBankFreePostingLines = { normalize, bankNetAmount, validate, postingId };
})(window);
